import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as DashboardLayout } from 'src/layouts/dashboard';

const IndexPage = lazy(() => import('src/pages/dashboard/index'));

const UserListPage = lazy(() => import('src/pages/dashboard/user/userList'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/createUser'));




export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />
      },
      {
        path: 'user',
        children: [
          {
            index: true,
            element: <UserListPage />
          },
          {
            path: 'createUser',
            element: <UserCreatePage />
          }
        ]
      },
    ]
  }
];
